module.exports = __webpack_public_path__ + "img/login-bg-left-img.f8771101.png";